const initSliders = async () => {
  if (document.querySelector('.block-academic')) {
    const { default: Swiper, Autoplay } = await import('swiper');

    Swiper.use([Autoplay]);

    new Swiper('.block-academic .swiper-container', {
      init: false,
      speed: 400,
      centeredSlides: true,
      autoplay: {
        delay: 1000
      },
      loop: true,
      slidesPerView: 'auto',
      loopedSlides: 5
    }).init();
  }
}

let slidersInitialized = false;

document.addEventListener('scroll', () => {
  if (!slidersInitialized) {
    slidersInitialized = true;
    initSliders();
  }
});
